import React from "react";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import { menusForDisplay } from '../domain/menus';


interface Props {
    menuLists: menusForDisplay[],
    handleClose: VoidFunction,
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nested: {
      paddingLeft: theme.spacing(4),
    },
  }),
);


const ModalMenuList: React.FC<Props> = props => {
  const classes = useStyles();

  const list = props.menuLists.map((menu, index) => {
    return (
      <Link
        href={"#" + menu.anchor}
        key={index}
      >
        <ListItem
          button
          onClick={props.handleClose}
          className={classes.nested}
        >
          <ListItemIcon>
            {menu.icon}
          </ListItemIcon>
          <ListItemText
            primary={menu.name}
            style={{ color: '#FFFFFF' }}
          />
        </ListItem>
      </Link>
    );
  });
  return (
    <List component="nav" aria-label="main mailbox folders">
        {list}
    </List>
  );
};


export default ModalMenuList;
